export default __webpack_public_path__ + "static/SSSpyView_screenshot-2@mob-1ce41fb77a86b71f4ee469cdd0edb0ea.jpg";